import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';
import anime from "animejs";
import {init360Images} from "./init360Images";

export function openFullscreenGallery(clickedElement, selectorImg = ".js-openGallery",videoLightBox=false) {
    const showNavigation = true;
    let cleanupZoom = null;

    function buildSwiperWrapper(medias) {
        const swiperWrapper = document.createElement('div');
        swiperWrapper.classList.add('swiper-wrapper');
        for (let media of medias) {
            const mediaSlide = document.createElement('div');
            mediaSlide.classList.add('swiper-slide');
            switch (media.type) {
                case "video":
                case "embed":
                    mediaSlide.innerHTML = media.src;
                    break;
                case "viewer360":
                    mediaSlide.innerHTML = media.src;
                    break;
                case "image":
                    mediaSlide.innerHTML = "<img src='" + media.src + "' alt='" + media.src + "'/>";
                    break;
                case "videoPlayer":
                    mediaSlide.appendChild(media.src);
                    break;
            }
            swiperWrapper.appendChild(mediaSlide);
        }

        return swiperWrapper;
    }

    function buildFullscreenGallery() {
        const arrOriginals = [];
        const arrThumbs = [];
        const gallery = clickedElement.dataset.gallery;

        if (!gallery) {
            return false;
        }

        let count = 0;
        let lengthGalleries = document.querySelectorAll('fullscreenGallery');

        if (lengthGalleries) {
            count = lengthGalleries.length;
        }

        const id = "fullscreenGallery-" + count;
        let i = 0;
        for (let imagesFullscreen of document.querySelectorAll(selectorImg+"[data-gallery='"+gallery+"']")) {
            let img = imagesFullscreen.querySelector('img');
            let video = imagesFullscreen.querySelector('video');
            let embed = imagesFullscreen.querySelector('iframe');
            let videoPlayer = imagesFullscreen.querySelector('.js-video-player');

            let objMedia = {};
            let objMediaThumb = {};
            let isInArray = false;
            let thumb = imagesFullscreen.dataset.thumb;

            if (img) {
                objMedia.type = "image";
                objMedia.src = imagesFullscreen.dataset.original;
                imagesFullscreen.setAttribute('data-gallery-id', id);
                if(thumb === undefined){
                    thumb = img.src;
                }
            }
            if (video && !videoPlayer) {
                video.style.width = "100%";
                video.setAttribute("autoplay",true);
                video.setAttribute("playsinline",true);
                video.setAttribute("muted",true);
                video.removeAttribute("controls");
                objMedia.type = "video";
                objMedia.src = video.outerHTML;
            }
            if(videoPlayer){
                objMedia.type = "videoPlayer";
                objMedia.src = videoPlayer;
            }
            if (embed) {
                objMedia.type = "embed";
                objMedia.src = embed.outerHTML;
            }

            if(imagesFullscreen.classList.contains("js-load360")){
                objMedia.type = "viewer360";
                objMedia.src = "<div class='viewer360' data-options='"+imagesFullscreen.dataset.options+"'></div>";
            }
            for (let insertedOrignal of arrOriginals) {
                if (insertedOrignal.src === objMedia.src) {
                    isInArray = true;
                    break;
                }
            }
            if(thumb){
                objMediaThumb.src = imagesFullscreen.dataset.thumb;
                objMediaThumb.type = "image";
            }
            if (!isInArray) {
                arrOriginals.push(objMedia);
                arrThumbs.push(objMediaThumb);
            }
            i++;
        }

        const fullgallery = document.createElement('div');
        fullgallery.classList.add('fullscreenSwiper');
        fullgallery.classList.add('fullscreenGallery');
        fullgallery.classList.add('is-loading');
        fullgallery.setAttribute('id', id);
        fullgallery.style.opacity = 0;

        //build gallery big images
        const galleryOriginalImages = document.createElement('div');
        galleryOriginalImages.classList.add('fullscreenSwiperImage');
        if(videoLightBox){
            galleryOriginalImages.classList.add('fullscreenSwiperVideo');

        }
        galleryOriginalImages.classList.add('swiper');

        //add images in big images wrapper
        const swiperWrapperOriginalImages = buildSwiperWrapper(arrOriginals);

        galleryOriginalImages.appendChild(swiperWrapperOriginalImages);

        if(showNavigation){
            let navigationElements = buildNavigation();
            galleryOriginalImages.appendChild(navigationElements[0]);
            galleryOriginalImages.appendChild(navigationElements[1]);
        }
        fullgallery.appendChild(galleryOriginalImages);

        if(arrOriginals.length > 1){
            //build gallery thumbs
            const galleryThumbs = document.createElement('div');
            galleryThumbs.classList.add('fullscreenSwiperThumbs');
            galleryThumbs.classList.add('swiper');
            //add images in thumbs wrapper
            const swiperWrapperThumbs = buildSwiperWrapper(arrThumbs, true);
            galleryThumbs.appendChild(swiperWrapperThumbs);

            fullgallery.appendChild(galleryThumbs);
        }

        //build gallery close button
        const galleryCloseButton = document.createElement('div');
        galleryCloseButton.classList.add('fullscreenSwiperClose');
        galleryCloseButton.innerHTML = "<i class=\"icon icon-close\" aria-hidden='true'></i>";

        fullgallery.appendChild(galleryCloseButton);

        fullgallery.appendChild(buildZoomControls());

        document.body.appendChild(fullgallery);

        return id;
    }

    function closeFullscreenGallery(gallery) {
        if(videoLightBox){
           const video= gallery.querySelector('.js-video-player');
            const oldVideoWrapper=document.querySelector(selectorImg);
            oldVideoWrapper.appendChild(video);

        }
        if (cleanupZoom) { cleanupZoom(); cleanupZoom = null; }
        anime({
            targets: gallery,
            opacity: 0,
            easing: 'linear',
            duration: 400,
            complete: function () {
                gallery.remove();
                document.body.classList.remove('fullscreen-gallery-opened');
            }
        });
    }

    function getCurrentSlideIndex(clickedElement) {
        if (clickedElement.dataset.index) {
            return clickedElement.dataset.index;
        } else {
            return 0;
        }
    }

    function resizeMainSwiper(swiper) {
        swiper.wrapperEl.style.height = swiper.height + "px";
    }

    function buildNavigation(){
        //build prev and next button
        const prevBtn = document.createElement('div');
        prevBtn.classList.add('swiper-button-prev');
        prevBtn.innerHTML = "<i class=\"icon icon-angle-left\" aria-hidden=\"true\" ></i>";

        const nextBtn = document.createElement('div');
        nextBtn.classList.add('swiper-button-next');
        nextBtn.innerHTML = "<i class=\"icon icon-angle-right\" aria-hidden=\"true\" ></i>";

        return [
            prevBtn,
            nextBtn
        ];
    }

    function handleVideos(curr){
        const activeSlide = curr.slides[curr.activeIndex];
        for(let slide of curr.slides){
            const videoElement = slide.querySelector('video');
            if(videoElement){
                if(slide === activeSlide){
                    videoElement.play();
                   // videoElement.muted = false;
                }else{
                    videoElement.pause();
                }
            }
        }
    }

    function handleViewer360(curr){
        const activeSlide = curr.slides[curr.activeIndex];
        if(!activeSlide) return;
        init360Images(activeSlide.querySelectorAll('.viewer360'));
    }

    function buildZoomControls() {
        const zoomControls = document.createElement('div');
        zoomControls.classList.add('fullscreenSwiperZoom');

        const zoomInBtn = document.createElement('button');
        zoomInBtn.classList.add('fullscreenSwiperZoom__btn', 'fullscreenSwiperZoom__btn--in');
        zoomInBtn.setAttribute('aria-label', 'Zoom in');
        zoomInBtn.innerHTML = "<i class=\"icon icon-plus\" aria-hidden='true'></i>";

        const zoomOutBtn = document.createElement('button');
        zoomOutBtn.classList.add('fullscreenSwiperZoom__btn', 'fullscreenSwiperZoom__btn--out');
        zoomOutBtn.setAttribute('aria-label', 'Zoom out');
        zoomOutBtn.innerHTML = "<i class=\"icon icon-minus\" aria-hidden='true'></i>";

        zoomControls.appendChild(zoomInBtn);
        zoomControls.appendChild(zoomOutBtn);

        return zoomControls;
    }

    function initZoom(fullgallery, galleryImage) {
        let zoomLevel = 1;
        let panX = 0;
        let panY = 0;
        const ZOOM_STEP = 0.5;
        const ZOOM_MIN = 1;
        const ZOOM_MAX = 4;

        const zoomInBtn = fullgallery.querySelector('.fullscreenSwiperZoom__btn--in');
        const zoomOutBtn = fullgallery.querySelector('.fullscreenSwiperZoom__btn--out');
        const swiperImageEl = fullgallery.querySelector('.fullscreenSwiperImage');

        let isDragging = false;
        let dragStartX = 0, dragStartY = 0, panStartX = 0, panStartY = 0;
        let pinchDist = null, pinchMidX = 0, pinchMidY = 0;

        function getActiveImg() {
            const activeSlide = galleryImage.slides[galleryImage.activeIndex];
            return activeSlide ? activeSlide.querySelector('img') : null;
        }

        function applyTransform() {
            const img = getActiveImg();
            if (!img) return;
            img.style.transformOrigin = 'center center';
            img.style.transition = 'transform 0.2s ease';
            img.style.transform = `scale(${zoomLevel}) translate(${panX}px, ${panY}px)`;
            zoomOutBtn.disabled = zoomLevel <= ZOOM_MIN;
            zoomInBtn.disabled = zoomLevel >= ZOOM_MAX;
            fullgallery.classList.toggle('is-zoomed', zoomLevel > 1);
        }

        function resetZoom() {
            zoomLevel = 1;
            panX = 0;
            panY = 0;
            for (const slide of galleryImage.slides) {
                const img = slide.querySelector('img');
                if (img) img.style.transform = '';
            }
            fullgallery.classList.remove('is-zoomed');
            zoomOutBtn.disabled = true;
            zoomInBtn.disabled = false;
        }

        zoomInBtn.addEventListener('click', () => {
            if (zoomLevel < ZOOM_MAX) {
                zoomLevel = Math.min(ZOOM_MAX, zoomLevel + ZOOM_STEP);
                applyTransform();
            }
        });

        zoomOutBtn.addEventListener('click', () => {
            if (zoomLevel > ZOOM_MIN) {
                zoomLevel = Math.max(ZOOM_MIN, zoomLevel - ZOOM_STEP);
                if (zoomLevel <= ZOOM_MIN) { panX = 0; panY = 0; }
                applyTransform();
            }
        });

        function getPinchDist(touches) {
            const dx = touches[0].clientX - touches[1].clientX;
            const dy = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }

        // Shared helper: zoom toward a focal point (screen coords) from oldZoom to newZoom
        function zoomTowardPoint(focalX, focalY, oldZoom, newZoom, img) {
            const rect = img.getBoundingClientRect();
            const rectCx = rect.left + rect.width / 2;
            const rectCy = rect.top + rect.height / 2;
            const dx = focalX - rectCx;
            const dy = focalY - rectCy;
            panX = dx * (1 / newZoom - 1 / oldZoom) + panX * (oldZoom / newZoom);
            panY = dy * (1 / newZoom - 1 / oldZoom) + panY * (oldZoom / newZoom);
        }

        function onWheel(e) {
            e.preventDefault();
            const img = getActiveImg();
            if (!img) return;
            const delta = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
            const newZoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoomLevel + delta));
            if (newZoom === zoomLevel) return;
            zoomTowardPoint(e.clientX, e.clientY, zoomLevel, newZoom, img);
            zoomLevel = newZoom;
            if (zoomLevel <= ZOOM_MIN) { panX = 0; panY = 0; }
            applyTransform();
        }

        function onMouseDown(e) {
            if (zoomLevel <= 1) return;
            isDragging = true;
            dragStartX = e.clientX;
            dragStartY = e.clientY;
            panStartX = panX;
            panStartY = panY;
            e.preventDefault();
        }

        function onMouseMove(e) {
            if (!isDragging) return;
            panX = panStartX + (e.clientX - dragStartX) / zoomLevel;
            panY = panStartY + (e.clientY - dragStartY) / zoomLevel;
            const img = getActiveImg();
            if (img) {
                img.style.transition = 'none';
                img.style.transform = `scale(${zoomLevel}) translate(${panX}px, ${panY}px)`;
            }
        }

        function onMouseUp() {
            isDragging = false;
        }

        function onTouchStart(e) {
            if (e.touches.length === 2) {
                isDragging = false;
                pinchDist = getPinchDist(e.touches);
                pinchMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                pinchMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            } else if (e.touches.length === 1 && zoomLevel > 1) {
                isDragging = true;
                dragStartX = e.touches[0].clientX;
                dragStartY = e.touches[0].clientY;
                panStartX = panX;
                panStartY = panY;
            }
        }

        function onTouchMove(e) {
            if (e.touches.length === 2 && pinchDist !== null) {
                e.preventDefault();
                e.stopPropagation();
                const img = getActiveImg();
                if (!img) return;
                const newDist = getPinchDist(e.touches);
                const scaleRatio = newDist / pinchDist;
                pinchDist = newDist;
                const newMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                const newMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                const midDX = newMidX - pinchMidX;
                const midDY = newMidY - pinchMidY;
                const newZoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoomLevel * scaleRatio));
                if (newZoom !== zoomLevel) {
                    zoomTowardPoint(pinchMidX, pinchMidY, zoomLevel, newZoom, img);
                    zoomLevel = newZoom;
                }
                panX += midDX / zoomLevel;
                panY += midDY / zoomLevel;
                if (zoomLevel <= ZOOM_MIN) { panX = 0; panY = 0; }
                img.style.transition = 'none';
                img.style.transform = `scale(${zoomLevel}) translate(${panX}px, ${panY}px)`;
                zoomOutBtn.disabled = zoomLevel <= ZOOM_MIN;
                zoomInBtn.disabled = zoomLevel >= ZOOM_MAX;
                fullgallery.classList.toggle('is-zoomed', zoomLevel > 1);
                pinchMidX = newMidX;
                pinchMidY = newMidY;
            } else if (e.touches.length === 1 && isDragging) {
                panX = panStartX + (e.touches[0].clientX - dragStartX) / zoomLevel;
                panY = panStartY + (e.touches[0].clientY - dragStartY) / zoomLevel;
                const img = getActiveImg();
                if (img) {
                    img.style.transition = 'none';
                    img.style.transform = `scale(${zoomLevel}) translate(${panX}px, ${panY}px)`;
                }
                e.stopPropagation();
            }
        }

        function onTouchEnd(e) {
            if (e.touches.length < 2) pinchDist = null;
            if (e.touches.length === 0) isDragging = false;
        }

        swiperImageEl.addEventListener('wheel', onWheel, { passive: false });
        swiperImageEl.addEventListener('mousedown', onMouseDown);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        swiperImageEl.addEventListener('touchstart', onTouchStart, { passive: true });
        swiperImageEl.addEventListener('touchmove', onTouchMove, { passive: false });
        swiperImageEl.addEventListener('touchend', onTouchEnd);

        galleryImage.on('slideChangeTransitionStart', resetZoom);

        zoomOutBtn.disabled = true;

        return function cleanup() {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            swiperImageEl.removeEventListener('wheel', onWheel);
        };
    }

    setTimeout(function () {
        let currentSlide = 0;
        let fullgalleryid = buildFullscreenGallery();
        currentSlide = getCurrentSlideIndex(clickedElement);

        let fullgallery = document.getElementById(fullgalleryid);

        if (fullgallery) {
            Swiper.use([Thumbs, Navigation]);

            let galleryThumbs = false;

            if(document.querySelector('#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs')){
                galleryThumbs = new Swiper('#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    slideToClickedSlide: true,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    preloadImages: true,
                    autoHeight: true,
                    initialSlide: parseInt(currentSlide),
                    navigation: {
                        nextEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs .swiper-button-next',
                        prevEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperThumbs .swiper-button-prev',
                    },
                    loop: false,
                    breakpoints: {
                        0: {
                            spaceBetween: 5,
                        },
                        768: {
                            spaceBetween: 10,
                        }
                    }
                });
            }

            let allowTouchMove = false;
            let touchRatio = 0;

            if (window.outerWidth < GLOBALS.gridBreakpoints.sm) {
                allowTouchMove = true;
                touchRatio = 1;
            }

            const galleryImage = new Swiper('#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperImage', {
                loop: true,
                slidesPerView: 1,
                initialSlide: parseInt(currentSlide),
                preloadImages: true,
                allowTouchMove: allowTouchMove,
                touchRatio: touchRatio,
                navigation: {
                    nextEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperImage .swiper-button-next',
                    prevEl: '#' + fullgalleryid + '.fullscreenSwiper .fullscreenSwiperImage .swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
                on: {
                    afterInit: function () {
                        fullgallery.style.display = "";
                        anime({
                            targets: fullgallery,
                            opacity: 1,
                            easing: 'linear',
                            duration: 200,
                            complete: function () {
                              //  resizeMainSwiper(galleryImage);
                                document.body.classList.add('fullscreen-gallery-opened');
                                setTimeout(function () {
                                    fullgallery.classList.remove("is-loading");
                                }, 200);
                            }
                        });
                        handleVideos(this);
                        handleViewer360(this);
                    },
                    slideChange: function () {
                        handleVideos(this);
                        handleViewer360(this);
                    }
                }
            });

            cleanupZoom = initZoom(fullgallery, galleryImage);

            fullgallery.querySelector('.fullscreenSwiperClose').addEventListener('click', () => {
                closeFullscreenGallery(fullgallery);
            });
            document.addEventListener("keydown", handleKeyDown);

            function handleKeyDown(e) {
                if (e.key === "Escape") {
                    closeFullscreenGallery(fullgallery);
                }
                if (e.key === "ArrowLeft") {
                    galleryImage.slidePrev(200);
                }
                if (e.key === "ArrowRight") {
                    galleryImage.slideNext(200);
                }
            }
        }
    }, 200);
}
